/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ExternalCallsService {
  /** @summary Metrics Registry */
  metricsRegistryExternalCallsMetricsRegistryGet: {
    /** @summary Metrics Registry */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<MetricsRegistryExternalCallsMetricsRegistryGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        options: {
          parameters: MetricsRegistryExternalCallsMetricsRegistryGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      >
    >;
    /** @summary Metrics Registry */
    getQueryKey(
      parameters: DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void
    ): ServiceOperationQueryKey<
      MetricsRegistryExternalCallsMetricsRegistryGetSchema,
      MetricsRegistryExternalCallsMetricsRegistryGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useQuery()
     * ```
     */
    useQuery<TData = MetricsRegistryExternalCallsMetricsRegistryGetData>(
      parameters:
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          TData,
          ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useQuery()
     * ```
     */
    useQuery<TData = MetricsRegistryExternalCallsMetricsRegistryGetData>(
      parameters:
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          TData,
          ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>>;
    /** @summary Metrics Registry */
    getInfiniteQueryKey(
      parameters: DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      MetricsRegistryExternalCallsMetricsRegistryGetSchema,
      MetricsRegistryExternalCallsMetricsRegistryGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters,
      TQueryFnData = MetricsRegistryExternalCallsMetricsRegistryGetData,
      TData = OperationInfiniteData<TQueryFnData, MetricsRegistryExternalCallsMetricsRegistryGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters,
      TQueryFnData = MetricsRegistryExternalCallsMetricsRegistryGetData,
      TData = OperationInfiniteData<TQueryFnData, MetricsRegistryExternalCallsMetricsRegistryGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const metricsRegistryExternalCallsMetricsRegistryGetTotal = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const metricsRegistryExternalCallsMetricsRegistryGetResults = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * metricsRegistryExternalCallsMetricsRegistryGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const metricsRegistryExternalCallsMetricsRegistryGetCombinedResults = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * metricsRegistryExternalCallsMetricsRegistryGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          MetricsRegistryExternalCallsMetricsRegistryGetSchema,
          MetricsRegistryExternalCallsMetricsRegistryGetParameters,
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = MetricsRegistryExternalCallsMetricsRegistryGetData>(
      parameters:
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          TData,
          ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters,
      TData = MetricsRegistryExternalCallsMetricsRegistryGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError,
          OperationInfiniteData<TData, MetricsRegistryExternalCallsMetricsRegistryGetParameters>,
          ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, MetricsRegistryExternalCallsMetricsRegistryGetParameters>,
      OperationError<MetricsRegistryExternalCallsMetricsRegistryGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Metrics Registry
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const metricsRegistryExternalCallsMetricsRegistryGetData = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * metricsRegistryExternalCallsMetricsRegistryGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const metricsRegistryExternalCallsMetricsRegistryGetCombinedData = qraft.externalCallsService.metricsRegistryExternalCallsMetricsRegistryGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * metricsRegistryExternalCallsMetricsRegistryGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          MetricsRegistryExternalCallsMetricsRegistryGetSchema,
          MetricsRegistryExternalCallsMetricsRegistryGetParameters,
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              MetricsRegistryExternalCallsMetricsRegistryGetData,
              MetricsRegistryExternalCallsMetricsRegistryGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Metrics Registry */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<MetricsRegistryExternalCallsMetricsRegistryGetData>;
    /** @summary Metrics Registry */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<void>;
    /** @summary Metrics Registry */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<MetricsRegistryExternalCallsMetricsRegistryGetData>;
    /** @summary Metrics Registry */
    fetchInfiniteQuery<TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        DeepReadonly<TPageParam>,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters
      >
    >;
    /** @summary Metrics Registry */
    prefetchInfiniteQuery<TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        DeepReadonly<TPageParam>,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<void>;
    /** @summary Metrics Registry */
    ensureInfiniteQueryData<TPageParam extends MetricsRegistryExternalCallsMetricsRegistryGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        DeepReadonly<TPageParam>,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      > | void
    ): Promise<
      OperationInfiniteData<
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters
      >
    >;
    /** @summary Metrics Registry */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void)
    ): MetricsRegistryExternalCallsMetricsRegistryGetData | undefined;
    /** @summary Metrics Registry */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void)
    ):
      | OperationInfiniteData<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetParameters
        >
      | undefined;
    /** @summary Metrics Registry */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              MetricsRegistryExternalCallsMetricsRegistryGetSchema,
              MetricsRegistryExternalCallsMetricsRegistryGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    MetricsRegistryExternalCallsMetricsRegistryGetData,
                    MetricsRegistryExternalCallsMetricsRegistryGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              MetricsRegistryExternalCallsMetricsRegistryGetSchema,
              MetricsRegistryExternalCallsMetricsRegistryGetParameters
            >,
            data: MetricsRegistryExternalCallsMetricsRegistryGetData | undefined,
          ]
        >;
    /** @summary Metrics Registry */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | void)
    ):
      | QueryState<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      | undefined;
    /** @summary Metrics Registry */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters>
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
          MetricsRegistryExternalCallsMetricsRegistryGetError
        >
      | undefined;
    /** @summary Metrics Registry */
    setQueryData(
      parameters:
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | undefined)
        | ServiceOperationQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
      updater: Updater<
        NoInfer<MetricsRegistryExternalCallsMetricsRegistryGetData> | undefined,
        NoInfer<DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetData>> | undefined
      >,
      options?: SetDataOptions
    ): MetricsRegistryExternalCallsMetricsRegistryGetData | undefined;
    /** @summary Metrics Registry */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<MetricsRegistryExternalCallsMetricsRegistryGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              MetricsRegistryExternalCallsMetricsRegistryGetData,
              MetricsRegistryExternalCallsMetricsRegistryGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                MetricsRegistryExternalCallsMetricsRegistryGetData,
                MetricsRegistryExternalCallsMetricsRegistryGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          MetricsRegistryExternalCallsMetricsRegistryGetData,
          MetricsRegistryExternalCallsMetricsRegistryGetParameters
        >
      | undefined;
    /** @summary Metrics Registry */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >,
      updater: Updater<
        NoInfer<MetricsRegistryExternalCallsMetricsRegistryGetData> | undefined,
        NoInfer<MetricsRegistryExternalCallsMetricsRegistryGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<MetricsRegistryExternalCallsMetricsRegistryGetData | undefined>;
    /** @summary Metrics Registry */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        MetricsRegistryExternalCallsMetricsRegistryGetSchema,
        MetricsRegistryExternalCallsMetricsRegistryGetData,
        TInfinite,
        MetricsRegistryExternalCallsMetricsRegistryGetParameters,
        MetricsRegistryExternalCallsMetricsRegistryGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Metrics Registry */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Metrics Registry */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Metrics Registry */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
    ): void;
    /** @summary Metrics Registry */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Metrics Registry */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
        | QueryFiltersByQueryKey<
            MetricsRegistryExternalCallsMetricsRegistryGetSchema,
            MetricsRegistryExternalCallsMetricsRegistryGetData,
            TInfinite,
            MetricsRegistryExternalCallsMetricsRegistryGetParameters,
            MetricsRegistryExternalCallsMetricsRegistryGetError
          >
    ): number;
    schema: MetricsRegistryExternalCallsMetricsRegistryGetSchema;
    types: {
      parameters: MetricsRegistryExternalCallsMetricsRegistryGetParameters;
      data: MetricsRegistryExternalCallsMetricsRegistryGetData;
      error: MetricsRegistryExternalCallsMetricsRegistryGetError;
    };
  };
  /** @summary Search */
  searchExternalCallsGet: {
    /** @summary Search */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<SearchExternalCallsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: SearchExternalCallsGetSchema,
        options: {
          parameters: SearchExternalCallsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<SearchExternalCallsGetData, SearchExternalCallsGetError>>
    ): Promise<RequestFnResponse<SearchExternalCallsGetData, SearchExternalCallsGetError>>;
    /** @summary Search */
    getQueryKey(
      parameters: DeepReadonly<SearchExternalCallsGetParameters> | void
    ): ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.searchExternalCallsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.searchExternalCallsGet.useQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchExternalCallsGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          SearchExternalCallsGetData,
          SearchExternalCallsGetError,
          TData,
          ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<SearchExternalCallsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.searchExternalCallsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.searchExternalCallsGet.useQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchExternalCallsGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          SearchExternalCallsGetData,
          SearchExternalCallsGetError,
          TData,
          ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<SearchExternalCallsGetError>>;
    /** @summary Search */
    getInfiniteQueryKey(
      parameters: DeepReadonly<SearchExternalCallsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.searchExternalCallsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchExternalCallsGetParameters,
      TQueryFnData = SearchExternalCallsGetData,
      TData = OperationInfiniteData<TQueryFnData, SearchExternalCallsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchExternalCallsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<SearchExternalCallsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.searchExternalCallsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchExternalCallsGetParameters,
      TQueryFnData = SearchExternalCallsGetData,
      TData = OperationInfiniteData<TQueryFnData, SearchExternalCallsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchExternalCallsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchExternalCallsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<SearchExternalCallsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const searchExternalCallsGetTotal = qraft.externalCallsService.searchExternalCallsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const searchExternalCallsGetByParametersTotal = qraft.externalCallsService.searchExternalCallsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             page: page
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const searchExternalCallsGetResults = qraft.externalCallsService.searchExternalCallsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchExternalCallsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const searchExternalCallsGetCombinedResults = qraft.externalCallsService.searchExternalCallsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchExternalCallsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          SearchExternalCallsGetSchema,
          SearchExternalCallsGetParameters,
          SearchExternalCallsGetData,
          SearchExternalCallsGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<SearchExternalCallsGetData, SearchExternalCallsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<SearchExternalCallsGetData, SearchExternalCallsGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.externalCallsService.searchExternalCallsGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.searchExternalCallsGet.useSuspenseQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = SearchExternalCallsGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          SearchExternalCallsGetData,
          SearchExternalCallsGetError,
          TData,
          ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<SearchExternalCallsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.searchExternalCallsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends SearchExternalCallsGetParameters, TData = SearchExternalCallsGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          SearchExternalCallsGetData,
          SearchExternalCallsGetError,
          OperationInfiniteData<TData, SearchExternalCallsGetParameters>,
          ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchExternalCallsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, SearchExternalCallsGetParameters>,
      OperationError<SearchExternalCallsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const searchExternalCallsGetData = qraft.externalCallsService.searchExternalCallsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchExternalCallsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const searchExternalCallsGetCombinedData = qraft.externalCallsService.searchExternalCallsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * searchExternalCallsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          SearchExternalCallsGetSchema,
          SearchExternalCallsGetParameters,
          SearchExternalCallsGetData,
          SearchExternalCallsGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<SearchExternalCallsGetData, SearchExternalCallsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<SearchExternalCallsGetData, SearchExternalCallsGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Search */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        SearchExternalCallsGetError
      > | void
    ): Promise<SearchExternalCallsGetData>;
    /** @summary Search */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        SearchExternalCallsGetError
      > | void
    ): Promise<void>;
    /** @summary Search */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        SearchExternalCallsGetError
      > | void
    ): Promise<SearchExternalCallsGetData>;
    /** @summary Search */
    fetchInfiniteQuery<TPageParam extends SearchExternalCallsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        DeepReadonly<TPageParam>,
        SearchExternalCallsGetError
      > | void
    ): Promise<OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>>;
    /** @summary Search */
    prefetchInfiniteQuery<TPageParam extends SearchExternalCallsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        DeepReadonly<TPageParam>,
        SearchExternalCallsGetError
      > | void
    ): Promise<void>;
    /** @summary Search */
    ensureInfiniteQueryData<TPageParam extends SearchExternalCallsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        SearchExternalCallsGetParameters,
        DeepReadonly<TPageParam>,
        SearchExternalCallsGetError
      > | void
    ): Promise<OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>>;
    /** @summary Search */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void)
    ): SearchExternalCallsGetData | undefined;
    /** @summary Search */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void)
    ): OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters> | undefined;
    /** @summary Search */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
            data:
              | NoInfer<OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
            data: SearchExternalCallsGetData | undefined,
          ]
        >;
    /** @summary Search */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | (DeepReadonly<SearchExternalCallsGetParameters> | void)
    ): QueryState<SearchExternalCallsGetData, SearchExternalCallsGetError> | undefined;
    /** @summary Search */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<SearchExternalCallsGetParameters>
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>,
          SearchExternalCallsGetError
        >
      | undefined;
    /** @summary Search */
    setQueryData(
      parameters:
        | (DeepReadonly<SearchExternalCallsGetParameters> | undefined)
        | ServiceOperationQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
      updater: Updater<
        NoInfer<SearchExternalCallsGetData> | undefined,
        NoInfer<DeepReadonly<SearchExternalCallsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): SearchExternalCallsGetData | undefined;
    /** @summary Search */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<SearchExternalCallsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<SearchExternalCallsGetSchema, SearchExternalCallsGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<SearchExternalCallsGetData, SearchExternalCallsGetParameters> | undefined;
    /** @summary Search */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >,
      updater: Updater<
        NoInfer<SearchExternalCallsGetData> | undefined,
        NoInfer<SearchExternalCallsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<SearchExternalCallsGetData | undefined>;
    /** @summary Search */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        SearchExternalCallsGetSchema,
        SearchExternalCallsGetData,
        TInfinite,
        SearchExternalCallsGetParameters,
        SearchExternalCallsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Search */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Search */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Search */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
    ): void;
    /** @summary Search */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Search */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
        | QueryFiltersByQueryKey<
            SearchExternalCallsGetSchema,
            SearchExternalCallsGetData,
            TInfinite,
            SearchExternalCallsGetParameters,
            SearchExternalCallsGetError
          >
    ): number;
    schema: SearchExternalCallsGetSchema;
    types: {
      parameters: SearchExternalCallsGetParameters;
      data: SearchExternalCallsGetData;
      error: SearchExternalCallsGetError;
    };
  };
  /**
   * @summary Get By Id
   * @description Fetch a single external call by its ID.
   */
  getByIdExternalCallsExternalCallIdGet: {
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetByIdExternalCallsExternalCallIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetByIdExternalCallsExternalCallIdGetSchema,
        options: {
          parameters: GetByIdExternalCallsExternalCallIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError>
      >
    ): Promise<
      RequestFnResponse<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError>
    >;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
    ): ServiceOperationQueryKey<
      GetByIdExternalCallsExternalCallIdGetSchema,
      GetByIdExternalCallsExternalCallIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetByIdExternalCallsExternalCallIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetByIdExternalCallsExternalCallIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetByIdExternalCallsExternalCallIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetByIdExternalCallsExternalCallIdGetError>>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetByIdExternalCallsExternalCallIdGetSchema,
      GetByIdExternalCallsExternalCallIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters,
      TQueryFnData = GetByIdExternalCallsExternalCallIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetByIdExternalCallsExternalCallIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetByIdExternalCallsExternalCallIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetByIdExternalCallsExternalCallIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters,
      TQueryFnData = GetByIdExternalCallsExternalCallIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetByIdExternalCallsExternalCallIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetByIdExternalCallsExternalCallIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetByIdExternalCallsExternalCallIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetTotal = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetByParametersTotal = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             external_call_id: externalCallId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetResults = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2
     *             }
     *         }
     *     ]
     * });
     * getByIdExternalCallsExternalCallIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetCombinedResults = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2
     *             }
     *         }
     *     ]
     * });
     * getByIdExternalCallsExternalCallIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetByIdExternalCallsExternalCallIdGetSchema,
          GetByIdExternalCallsExternalCallIdGetParameters,
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useSuspenseQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetByIdExternalCallsExternalCallIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetByIdExternalCallsExternalCallIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters,
      TData = GetByIdExternalCallsExternalCallIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError,
          OperationInfiniteData<TData, GetByIdExternalCallsExternalCallIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetByIdExternalCallsExternalCallIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetByIdExternalCallsExternalCallIdGetParameters>,
      OperationError<GetByIdExternalCallsExternalCallIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetData = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2
     *             }
     *         }
     *     ]
     * });
     * getByIdExternalCallsExternalCallIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getByIdExternalCallsExternalCallIdGetCombinedData = qraft.externalCallsService.getByIdExternalCallsExternalCallIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2
     *             }
     *         }
     *     ]
     * });
     * getByIdExternalCallsExternalCallIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetByIdExternalCallsExternalCallIdGetSchema,
          GetByIdExternalCallsExternalCallIdGetParameters,
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetByIdExternalCallsExternalCallIdGetData,
              GetByIdExternalCallsExternalCallIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<GetByIdExternalCallsExternalCallIdGetData>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<GetByIdExternalCallsExternalCallIdGetData>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    fetchInfiniteQuery<TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<
      OperationInfiniteData<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetParameters>
    >;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetByIdExternalCallsExternalCallIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        GetByIdExternalCallsExternalCallIdGetParameters,
        DeepReadonly<TPageParam>,
        GetByIdExternalCallsExternalCallIdGetError
      >
    ): Promise<
      OperationInfiniteData<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetParameters>
    >;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
    ): GetByIdExternalCallsExternalCallIdGetData | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
    ):
      | OperationInfiniteData<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetParameters
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetByIdExternalCallsExternalCallIdGetSchema,
              GetByIdExternalCallsExternalCallIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetByIdExternalCallsExternalCallIdGetData,
                    GetByIdExternalCallsExternalCallIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetByIdExternalCallsExternalCallIdGetSchema,
              GetByIdExternalCallsExternalCallIdGetParameters
            >,
            data: GetByIdExternalCallsExternalCallIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
    ): QueryState<GetByIdExternalCallsExternalCallIdGetData, GetByIdExternalCallsExternalCallIdGetError> | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetByIdExternalCallsExternalCallIdGetData,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
          GetByIdExternalCallsExternalCallIdGetError
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
        | ServiceOperationQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetByIdExternalCallsExternalCallIdGetData> | undefined,
        NoInfer<DeepReadonly<GetByIdExternalCallsExternalCallIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetByIdExternalCallsExternalCallIdGetData | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetByIdExternalCallsExternalCallIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetByIdExternalCallsExternalCallIdGetData,
              GetByIdExternalCallsExternalCallIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetByIdExternalCallsExternalCallIdGetData,
                GetByIdExternalCallsExternalCallIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetByIdExternalCallsExternalCallIdGetData,
          GetByIdExternalCallsExternalCallIdGetParameters
        >
      | undefined;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >,
      updater: Updater<
        NoInfer<GetByIdExternalCallsExternalCallIdGetData> | undefined,
        NoInfer<GetByIdExternalCallsExternalCallIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetByIdExternalCallsExternalCallIdGetData | undefined>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetByIdExternalCallsExternalCallIdGetSchema,
        GetByIdExternalCallsExternalCallIdGetData,
        TInfinite,
        GetByIdExternalCallsExternalCallIdGetParameters,
        GetByIdExternalCallsExternalCallIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
    ): void;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get By Id
     * @description Fetch a single external call by its ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
        | QueryFiltersByQueryKey<
            GetByIdExternalCallsExternalCallIdGetSchema,
            GetByIdExternalCallsExternalCallIdGetData,
            TInfinite,
            GetByIdExternalCallsExternalCallIdGetParameters,
            GetByIdExternalCallsExternalCallIdGetError
          >
    ): number;
    schema: GetByIdExternalCallsExternalCallIdGetSchema;
    types: {
      parameters: GetByIdExternalCallsExternalCallIdGetParameters;
      data: GetByIdExternalCallsExternalCallIdGetData;
      error: GetByIdExternalCallsExternalCallIdGetError;
    };
  };
  /**
   * @summary Get Distinct Values
   * @description Return distinct values for a given ExternalCall field for the provided office.
   */
  getDistinctValuesExternalCallsDistinctValuesFieldNameGet: {
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        options: {
          parameters: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    >;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getQueryKey(
      parameters: DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
    ): ServiceOperationQueryKey<
      GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
      GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          TData,
          ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          TData,
          ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
      GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useInfiniteQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
      TQueryFnData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
      TData = OperationInfiniteData<TQueryFnData, GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useInfiniteQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
      TQueryFnData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
      TData = OperationInfiniteData<TQueryFnData, GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetTotal = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetByParametersTotal = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             field_name: fieldName
     *         },
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetResults = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 field_name: fieldName1
     *             },
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 field_name: fieldName2
     *             },
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getDistinctValuesExternalCallsDistinctValuesFieldNameGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetCombinedResults = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 field_name: fieldName1
     *             },
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 field_name: fieldName2
     *             },
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getDistinctValuesExternalCallsDistinctValuesFieldNameGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useSuspenseQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          TData,
          ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useSuspenseInfiniteQuery({
     *     path: {
     *         field_name: fieldName
     *     },
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
      TData = GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError,
          OperationInfiniteData<TData, GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>,
      OperationError<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetData = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 field_name: fieldName1
     *             },
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 field_name: fieldName2
     *             },
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getDistinctValuesExternalCallsDistinctValuesFieldNameGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getDistinctValuesExternalCallsDistinctValuesFieldNameGetCombinedData = qraft.externalCallsService.getDistinctValuesExternalCallsDistinctValuesFieldNameGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 field_name: fieldName1
     *             },
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 field_name: fieldName2
     *             },
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getDistinctValuesExternalCallsDistinctValuesFieldNameGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    fetchInfiniteQuery<TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        DeepReadonly<TPageParam>,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
      >
    >;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    prefetchInfiniteQuery<TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        DeepReadonly<TPageParam>,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    ensureInfiniteQueryData<TPageParam extends GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        DeepReadonly<TPageParam>,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
      >
    >;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
    ): GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
    ):
      | OperationInfiniteData<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
        >
      | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
                    GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
            >,
            data: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData | undefined,
          ]
        >;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
    ):
      | QueryState<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
        >
      | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
        | ServiceOperationQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
      updater: Updater<
        NoInfer<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData> | undefined,
        NoInfer<DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
              GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
                GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
          GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters
        >
      | undefined;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >,
      updater: Updater<
        NoInfer<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData> | undefined,
        NoInfer<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData | undefined>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
        TInfinite,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
        GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
    ): void;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Distinct Values
     * @description Return distinct values for a given ExternalCall field for the provided office.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
        | QueryFiltersByQueryKey<
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData,
            TInfinite,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters,
            GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError
          >
    ): number;
    schema: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema;
    types: {
      parameters: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters;
      data: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData;
      error: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError;
    };
  };
  /**
   * @summary Get Recording Media Url
   * @description Fetch the media URL for a single external call recording by its ID.
   */
  getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet: {
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            TMeta,
            TSignal
          >,
      client?: (
        schema: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        options: {
          parameters: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
    ): ServiceOperationQueryKey<
      GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
      GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          TData,
          ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<
      TData,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          TData,
          ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<
      TData,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
      GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
      TQueryFnData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<
      TData,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
      TQueryFnData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
      TData = OperationInfiniteData<
        TQueryFnData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
      >,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<
      TData,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetTotal = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetByParametersTotal = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             external_call_id: externalCallId,
     *             external_call_recording_id: externalCallRecordingId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetResults = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1,
     *                 external_call_recording_id: externalCallRecordingId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2,
     *                 external_call_recording_id: externalCallRecordingId2
     *             }
     *         }
     *     ]
     * });
     * getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetCombinedResults = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1,
     *                 external_call_recording_id: externalCallRecordingId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2,
     *                 external_call_recording_id: externalCallRecordingId2
     *             }
     *         }
     *     ]
     * });
     * getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useSuspenseQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<
      TData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
    >(
      parameters:
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          TData,
          ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<
      TData,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useSuspenseInfiniteQuery({
     *     path: {
     *         external_call_id: externalCallId,
     *         external_call_recording_id: externalCallRecordingId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
      TData = GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError,
          OperationInfiniteData<
            TData,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
          ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<
        TData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
      >,
      OperationError<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1,
     *                 external_call_recording_id: externalCallRecordingId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2,
     *                 external_call_recording_id: externalCallRecordingId2
     *             }
     *         }
     *     ]
     * });
     * getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetCombinedData = qraft.externalCallsService.getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 external_call_id: externalCallId1,
     *                 external_call_recording_id: externalCallRecordingId1
     *             }
     *         },
     *         {
     *             path: {
     *                 external_call_id: externalCallId2,
     *                 external_call_recording_id: externalCallRecordingId2
     *             }
     *         }
     *     ]
     * });
     * getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    fetchInfiniteQuery<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
    >(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        DeepReadonly<TPageParam>,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
      >
    >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    prefetchInfiniteQuery<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
    >(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        DeepReadonly<TPageParam>,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    ensureInfiniteQueryData<
      TPageParam extends
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
    >(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        DeepReadonly<TPageParam>,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
      >
    >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
    ): GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
    ):
      | OperationInfiniteData<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
        >
      | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
                    GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
            >,
            data:
              | GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData
              | undefined,
          ]
        >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
    ):
      | QueryState<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
        >
      | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
        | ServiceOperationQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
      updater: Updater<
        | NoInfer<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>
        | undefined,
        | NoInfer<
            DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
              GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
                GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
          GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters
        >
      | undefined;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >,
      updater: Updater<
        | NoInfer<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>
        | undefined,
        | NoInfer<GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData>
        | undefined
      >,
      options?: SetDataOptions
    ): Array<
      GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData | undefined
    >;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
        TInfinite,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
        GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
    ): void;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Recording Media Url
     * @description Fetch the media URL for a single external call recording by its ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
        | QueryFiltersByQueryKey<
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData,
            TInfinite,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters,
            GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError
          >
    ): number;
    schema: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema;
    types: {
      parameters: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters;
      data: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData;
      error: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError;
    };
  };
  /**
   * @summary Get Aggregate Metrics
   * @description Return aggregated metrics for calls, grouped by CSR (user_name).
   */
  getAggregateMetricsExternalCallsMetricsAggregateGet: {
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        options: {
          parameters: GetAggregateMetricsExternalCallsMetricsAggregateGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    >;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueryKey(
      parameters: DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
    ): ServiceOperationQueryKey<
      GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
      GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAggregateMetricsExternalCallsMetricsAggregateGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          TData,
          ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAggregateMetricsExternalCallsMetricsAggregateGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          TData,
          ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
      GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useInfiniteQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             group_by: initialGroupBy,
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
      TQueryFnData = GetAggregateMetricsExternalCallsMetricsAggregateGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useInfiniteQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             group_by: initialGroupBy,
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
      TQueryFnData = GetAggregateMetricsExternalCallsMetricsAggregateGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetTotal = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetByParametersTotal = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             group_by: groupBy,
     *             from_date: fromDate,
     *             to_date: toDate
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetResults = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 group_by: groupBy1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 group_by: groupBy2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getAggregateMetricsExternalCallsMetricsAggregateGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetCombinedResults = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 group_by: groupBy1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 group_by: groupBy2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getAggregateMetricsExternalCallsMetricsAggregateGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
          GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useSuspenseQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAggregateMetricsExternalCallsMetricsAggregateGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          TData,
          ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useSuspenseInfiniteQuery({
     *     query: {
     *         group_by: groupBy,
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             group_by: initialGroupBy,
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
      TData = GetAggregateMetricsExternalCallsMetricsAggregateGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError,
          OperationInfiniteData<TData, GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>,
      OperationError<GetAggregateMetricsExternalCallsMetricsAggregateGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetData = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 group_by: groupBy1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 group_by: groupBy2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getAggregateMetricsExternalCallsMetricsAggregateGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAggregateMetricsExternalCallsMetricsAggregateGetCombinedData = qraft.externalCallsService.getAggregateMetricsExternalCallsMetricsAggregateGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 group_by: groupBy1,
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 group_by: groupBy2,
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getAggregateMetricsExternalCallsMetricsAggregateGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
          GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetAggregateMetricsExternalCallsMetricsAggregateGetData,
              GetAggregateMetricsExternalCallsMetricsAggregateGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<GetAggregateMetricsExternalCallsMetricsAggregateGetData>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<GetAggregateMetricsExternalCallsMetricsAggregateGetData>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    fetchInfiniteQuery<TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        DeepReadonly<TPageParam>,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
      >
    >;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    prefetchInfiniteQuery<TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        DeepReadonly<TPageParam>,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    ensureInfiniteQueryData<TPageParam extends GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        DeepReadonly<TPageParam>,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
      >
    >;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
    ): GetAggregateMetricsExternalCallsMetricsAggregateGetData | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
    ):
      | OperationInfiniteData<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
        >
      | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
              GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetAggregateMetricsExternalCallsMetricsAggregateGetData,
                    GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
              GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
            >,
            data: GetAggregateMetricsExternalCallsMetricsAggregateGetData | undefined,
          ]
        >;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
    ):
      | QueryState<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
          GetAggregateMetricsExternalCallsMetricsAggregateGetError
        >
      | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
        | ServiceOperationQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
      updater: Updater<
        NoInfer<GetAggregateMetricsExternalCallsMetricsAggregateGetData> | undefined,
        NoInfer<DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAggregateMetricsExternalCallsMetricsAggregateGetData | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetAggregateMetricsExternalCallsMetricsAggregateGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetAggregateMetricsExternalCallsMetricsAggregateGetData,
              GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetAggregateMetricsExternalCallsMetricsAggregateGetData,
                GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetAggregateMetricsExternalCallsMetricsAggregateGetData,
          GetAggregateMetricsExternalCallsMetricsAggregateGetParameters
        >
      | undefined;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >,
      updater: Updater<
        NoInfer<GetAggregateMetricsExternalCallsMetricsAggregateGetData> | undefined,
        NoInfer<GetAggregateMetricsExternalCallsMetricsAggregateGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAggregateMetricsExternalCallsMetricsAggregateGetData | undefined>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
        GetAggregateMetricsExternalCallsMetricsAggregateGetData,
        TInfinite,
        GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
        GetAggregateMetricsExternalCallsMetricsAggregateGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
    ): void;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Aggregate Metrics
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
        | QueryFiltersByQueryKey<
            GetAggregateMetricsExternalCallsMetricsAggregateGetSchema,
            GetAggregateMetricsExternalCallsMetricsAggregateGetData,
            TInfinite,
            GetAggregateMetricsExternalCallsMetricsAggregateGetParameters,
            GetAggregateMetricsExternalCallsMetricsAggregateGetError
          >
    ): number;
    schema: GetAggregateMetricsExternalCallsMetricsAggregateGetSchema;
    types: {
      parameters: GetAggregateMetricsExternalCallsMetricsAggregateGetParameters;
      data: GetAggregateMetricsExternalCallsMetricsAggregateGetData;
      error: GetAggregateMetricsExternalCallsMetricsAggregateGetError;
    };
  };
  /**
   * @summary Get Call Stats
   * @description Return aggregated metrics for calls, grouped by CSR (user_name).
   */
  getCallStatsExternalCallsAggregateCallStatsGet: {
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetCallStatsExternalCallsAggregateCallStatsGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        options: {
          parameters: GetCallStatsExternalCallsAggregateCallStatsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    >;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueryKey(
      parameters: DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
    ): ServiceOperationQueryKey<
      GetCallStatsExternalCallsAggregateCallStatsGetSchema,
      GetCallStatsExternalCallsAggregateCallStatsGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCallStatsExternalCallsAggregateCallStatsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCallStatsExternalCallsAggregateCallStatsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetCallStatsExternalCallsAggregateCallStatsGetSchema,
      GetCallStatsExternalCallsAggregateCallStatsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useInfiniteQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters,
      TQueryFnData = GetCallStatsExternalCallsAggregateCallStatsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useInfiniteQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters,
      TQueryFnData = GetCallStatsExternalCallsAggregateCallStatsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetTotal = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetByParametersTotal = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             from_date: fromDate,
     *             to_date: toDate
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetResults = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsExternalCallsAggregateCallStatsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetCombinedResults = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsExternalCallsAggregateCallStatsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetCallStatsExternalCallsAggregateCallStatsGetSchema,
          GetCallStatsExternalCallsAggregateCallStatsGetParameters,
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useSuspenseQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetCallStatsExternalCallsAggregateCallStatsGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          TData,
          ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useSuspenseInfiniteQuery({
     *     query: {
     *         from_date: fromDate,
     *         to_date: toDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             from_date: initialFromDate,
     *             to_date: initialToDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters,
      TData = GetCallStatsExternalCallsAggregateCallStatsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError,
          OperationInfiniteData<TData, GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetCallStatsExternalCallsAggregateCallStatsGetParameters>,
      OperationError<GetCallStatsExternalCallsAggregateCallStatsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetData = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsExternalCallsAggregateCallStatsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getCallStatsExternalCallsAggregateCallStatsGetCombinedData = qraft.externalCallsService.getCallStatsExternalCallsAggregateCallStatsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 from_date: fromDate1,
     *                 to_date: toDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 from_date: fromDate2,
     *                 to_date: toDate2
     *             }
     *         }
     *     ]
     * });
     * getCallStatsExternalCallsAggregateCallStatsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetCallStatsExternalCallsAggregateCallStatsGetSchema,
          GetCallStatsExternalCallsAggregateCallStatsGetParameters,
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetCallStatsExternalCallsAggregateCallStatsGetData,
              GetCallStatsExternalCallsAggregateCallStatsGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<GetCallStatsExternalCallsAggregateCallStatsGetData>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<GetCallStatsExternalCallsAggregateCallStatsGetData>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    fetchInfiniteQuery<TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        DeepReadonly<TPageParam>,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters
      >
    >;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    prefetchInfiniteQuery<TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        DeepReadonly<TPageParam>,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    ensureInfiniteQueryData<TPageParam extends GetCallStatsExternalCallsAggregateCallStatsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        DeepReadonly<TPageParam>,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters
      >
    >;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
    ): GetCallStatsExternalCallsAggregateCallStatsGetData | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
    ):
      | OperationInfiniteData<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetParameters
        >
      | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetCallStatsExternalCallsAggregateCallStatsGetSchema,
              GetCallStatsExternalCallsAggregateCallStatsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetCallStatsExternalCallsAggregateCallStatsGetData,
                    GetCallStatsExternalCallsAggregateCallStatsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetCallStatsExternalCallsAggregateCallStatsGetSchema,
              GetCallStatsExternalCallsAggregateCallStatsGetParameters
            >,
            data: GetCallStatsExternalCallsAggregateCallStatsGetData | undefined,
          ]
        >;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
    ):
      | QueryState<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
          GetCallStatsExternalCallsAggregateCallStatsGetError
        >
      | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
        | ServiceOperationQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
      updater: Updater<
        NoInfer<GetCallStatsExternalCallsAggregateCallStatsGetData> | undefined,
        NoInfer<DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetCallStatsExternalCallsAggregateCallStatsGetData | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetCallStatsExternalCallsAggregateCallStatsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetCallStatsExternalCallsAggregateCallStatsGetData,
              GetCallStatsExternalCallsAggregateCallStatsGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetCallStatsExternalCallsAggregateCallStatsGetData,
                GetCallStatsExternalCallsAggregateCallStatsGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetCallStatsExternalCallsAggregateCallStatsGetData,
          GetCallStatsExternalCallsAggregateCallStatsGetParameters
        >
      | undefined;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >,
      updater: Updater<
        NoInfer<GetCallStatsExternalCallsAggregateCallStatsGetData> | undefined,
        NoInfer<GetCallStatsExternalCallsAggregateCallStatsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetCallStatsExternalCallsAggregateCallStatsGetData | undefined>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetCallStatsExternalCallsAggregateCallStatsGetSchema,
        GetCallStatsExternalCallsAggregateCallStatsGetData,
        TInfinite,
        GetCallStatsExternalCallsAggregateCallStatsGetParameters,
        GetCallStatsExternalCallsAggregateCallStatsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
    ): void;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Call Stats
     * @description Return aggregated metrics for calls, grouped by CSR (user_name).
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
        | QueryFiltersByQueryKey<
            GetCallStatsExternalCallsAggregateCallStatsGetSchema,
            GetCallStatsExternalCallsAggregateCallStatsGetData,
            TInfinite,
            GetCallStatsExternalCallsAggregateCallStatsGetParameters,
            GetCallStatsExternalCallsAggregateCallStatsGetError
          >
    ): number;
    schema: GetCallStatsExternalCallsAggregateCallStatsGetSchema;
    types: {
      parameters: GetCallStatsExternalCallsAggregateCallStatsGetParameters;
      data: GetCallStatsExternalCallsAggregateCallStatsGetData;
      error: GetCallStatsExternalCallsAggregateCallStatsGetError;
    };
  };
  /**
   * @summary Override Call Metrics
   * @description Override call metrics for a given call.
   */
  overrideCallMetricsExternalCallsExternalCallIdMetricsPatch: {
    /**
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
        options: ServiceOperationMutationFnOptions<
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError
        >
      >
    ): Promise<
      RequestFnResponse<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError
      >
    >;
    /**
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     */
    getMutationKey(
      parameters: DeepReadonly<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters> | void
    ): ServiceOperationMutationKey<
      OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
      OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutation({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody, TContext = unknown>(
      parameters: DeepReadonly<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
        TVariables,
        OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
        TContext
      >
    ): UseMutationResult<
      OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
      OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutation({
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         external_call_id: externalCallId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
        TVariables,
        OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
        TContext
      >
    ): UseMutationResult<
      OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
      OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const overrideCallMetricsExternalCallsExternalCallIdMetricsPatchTotal = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const overrideCallMetricsExternalCallsExternalCallIdMetricsPatchTotal = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             external_call_id: externalCallId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const overrideCallMetricsExternalCallsExternalCallIdMetricsPatchPendingMutationVariables = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const overrideCallMetricsExternalCallsExternalCallIdMetricsPatchMutationData = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 external_call_id: externalCallId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
        OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
        MutationVariables<
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
          OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
          MutationVariables<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
            OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Override Call Metrics
     * @description Override call metrics for a given call.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             external_call_id: externalCallId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.externalCallsService.overrideCallMetricsExternalCallsExternalCallIdMetricsPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
              OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
              OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
              TContext
            >
      ):
        | Mutation<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError,
            MutationVariables<
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
              OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
              OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters,
              OperationError<OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData,
          OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError,
          MutationVariables<
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody,
            OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters
          >,
          TContext
        >
      >;
    };
    schema: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema;
    types: {
      parameters: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters;
      data: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData;
      error: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError;
      body: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody;
    };
  };
}
/** @summary Metrics Registry */
export const metricsRegistryExternalCallsMetricsRegistryGet = {
  schema: {
    method: 'get',
    url: '/external-calls/metrics_registry',
    security: ['HTTPBearer'],
  },
} as {
  schema: MetricsRegistryExternalCallsMetricsRegistryGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['metricsRegistryExternalCallsMetricsRegistryGet'];
};
/** @summary Search */
export const searchExternalCallsGet = {
  schema: {
    method: 'get',
    url: '/external-calls',
    security: ['HTTPBearer'],
  },
} as {
  schema: SearchExternalCallsGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['searchExternalCallsGet'];
};
/**
 * @summary Get By Id
 * @description Fetch a single external call by its ID.
 */
export const getByIdExternalCallsExternalCallIdGet = {
  schema: {
    method: 'get',
    url: '/external-calls/{external_call_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetByIdExternalCallsExternalCallIdGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getByIdExternalCallsExternalCallIdGet'];
};
/**
 * @summary Get Distinct Values
 * @description Return distinct values for a given ExternalCall field for the provided office.
 */
export const getDistinctValuesExternalCallsDistinctValuesFieldNameGet = {
  schema: {
    method: 'get',
    url: '/external-calls/distinct-values/{field_name}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getDistinctValuesExternalCallsDistinctValuesFieldNameGet'];
};
/**
 * @summary Get Recording Media Url
 * @description Fetch the media URL for a single external call recording by its ID.
 */
export const getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet = {
  schema: {
    method: 'get',
    url: '/external-calls/{external_call_id}/recording/{external_call_recording_id}/media-url',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet'];
};
/**
 * @summary Get Aggregate Metrics
 * @description Return aggregated metrics for calls, grouped by CSR (user_name).
 */
export const getAggregateMetricsExternalCallsMetricsAggregateGet = {
  schema: {
    method: 'get',
    url: '/external-calls/metrics/aggregate',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAggregateMetricsExternalCallsMetricsAggregateGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getAggregateMetricsExternalCallsMetricsAggregateGet'];
};
/**
 * @summary Get Call Stats
 * @description Return aggregated metrics for calls, grouped by CSR (user_name).
 */
export const getCallStatsExternalCallsAggregateCallStatsGet = {
  schema: {
    method: 'get',
    url: '/external-calls/aggregate/call-stats',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetCallStatsExternalCallsAggregateCallStatsGetSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['getCallStatsExternalCallsAggregateCallStatsGet'];
};
/**
 * @summary Override Call Metrics
 * @description Override call metrics for a given call.
 */
export const overrideCallMetricsExternalCallsExternalCallIdMetricsPatch = {
  schema: {
    method: 'patch',
    url: '/external-calls/{external_call_id}/metrics',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema;
  [QraftServiceOperationsToken]: ExternalCallsService['overrideCallMetricsExternalCallsExternalCallIdMetricsPatch'];
};
export const externalCallsService = {
  metricsRegistryExternalCallsMetricsRegistryGet,
  searchExternalCallsGet,
  getByIdExternalCallsExternalCallIdGet,
  getDistinctValuesExternalCallsDistinctValuesFieldNameGet,
  getRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGet,
  getAggregateMetricsExternalCallsMetricsAggregateGet,
  getCallStatsExternalCallsAggregateCallStatsGet,
  overrideCallMetricsExternalCallsExternalCallIdMetricsPatch,
} as const;
type MetricsRegistryExternalCallsMetricsRegistryGetSchema = {
  method: 'get';
  url: '/external-calls/metrics_registry';
  security: ['HTTPBearer'];
};
type MetricsRegistryExternalCallsMetricsRegistryGetParameters = undefined;
type MetricsRegistryExternalCallsMetricsRegistryGetData =
  paths['/external-calls/metrics_registry']['get']['responses']['200']['content']['application/json'];
type MetricsRegistryExternalCallsMetricsRegistryGetError = unknown;
type SearchExternalCallsGetSchema = {
  method: 'get';
  url: '/external-calls';
  security: ['HTTPBearer'];
};
type SearchExternalCallsGetParameters = paths['/external-calls']['get']['parameters'];
type SearchExternalCallsGetData = paths['/external-calls']['get']['responses']['200']['content']['application/json'];
type SearchExternalCallsGetError = paths['/external-calls']['get']['responses']['422']['content']['application/json'];
type GetByIdExternalCallsExternalCallIdGetSchema = {
  method: 'get';
  url: '/external-calls/{external_call_id}';
  security: ['HTTPBearer'];
};
type GetByIdExternalCallsExternalCallIdGetParameters = paths['/external-calls/{external_call_id}']['get']['parameters'];
type GetByIdExternalCallsExternalCallIdGetData =
  paths['/external-calls/{external_call_id}']['get']['responses']['200']['content']['application/json'];
type GetByIdExternalCallsExternalCallIdGetError =
  paths['/external-calls/{external_call_id}']['get']['responses']['422']['content']['application/json'];
type GetDistinctValuesExternalCallsDistinctValuesFieldNameGetSchema = {
  method: 'get';
  url: '/external-calls/distinct-values/{field_name}';
  security: ['HTTPBearer'];
};
type GetDistinctValuesExternalCallsDistinctValuesFieldNameGetParameters =
  paths['/external-calls/distinct-values/{field_name}']['get']['parameters'];
type GetDistinctValuesExternalCallsDistinctValuesFieldNameGetData =
  paths['/external-calls/distinct-values/{field_name}']['get']['responses']['200']['content']['application/json'];
type GetDistinctValuesExternalCallsDistinctValuesFieldNameGetError =
  paths['/external-calls/distinct-values/{field_name}']['get']['responses']['422']['content']['application/json'];
type GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetSchema = {
  method: 'get';
  url: '/external-calls/{external_call_id}/recording/{external_call_recording_id}/media-url';
  security: ['HTTPBearer'];
};
type GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetParameters =
  paths['/external-calls/{external_call_id}/recording/{external_call_recording_id}/media-url']['get']['parameters'];
type GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetData =
  paths['/external-calls/{external_call_id}/recording/{external_call_recording_id}/media-url']['get']['responses']['200']['content']['application/json'];
type GetRecordingMediaUrlExternalCallsExternalCallIdRecordingExternalCallRecordingIdMediaUrlGetError =
  paths['/external-calls/{external_call_id}/recording/{external_call_recording_id}/media-url']['get']['responses']['422']['content']['application/json'];
type GetAggregateMetricsExternalCallsMetricsAggregateGetSchema = {
  method: 'get';
  url: '/external-calls/metrics/aggregate';
  security: ['HTTPBearer'];
};
type GetAggregateMetricsExternalCallsMetricsAggregateGetParameters =
  paths['/external-calls/metrics/aggregate']['get']['parameters'];
type GetAggregateMetricsExternalCallsMetricsAggregateGetData =
  paths['/external-calls/metrics/aggregate']['get']['responses']['200']['content']['application/json'];
type GetAggregateMetricsExternalCallsMetricsAggregateGetError =
  paths['/external-calls/metrics/aggregate']['get']['responses']['422']['content']['application/json'];
type GetCallStatsExternalCallsAggregateCallStatsGetSchema = {
  method: 'get';
  url: '/external-calls/aggregate/call-stats';
  security: ['HTTPBearer'];
};
type GetCallStatsExternalCallsAggregateCallStatsGetParameters =
  paths['/external-calls/aggregate/call-stats']['get']['parameters'];
type GetCallStatsExternalCallsAggregateCallStatsGetData =
  paths['/external-calls/aggregate/call-stats']['get']['responses']['200']['content']['application/json'];
type GetCallStatsExternalCallsAggregateCallStatsGetError =
  paths['/external-calls/aggregate/call-stats']['get']['responses']['422']['content']['application/json'];
type OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchSchema = {
  method: 'patch';
  url: '/external-calls/{external_call_id}/metrics';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchParameters =
  paths['/external-calls/{external_call_id}/metrics']['patch']['parameters'];
type OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchData = null;
type OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchError =
  paths['/external-calls/{external_call_id}/metrics']['patch']['responses']['422']['content']['application/json'];
type OverrideCallMetricsExternalCallsExternalCallIdMetricsPatchBody =
  paths['/external-calls/{external_call_id}/metrics']['patch']['requestBody']['content']['application/json'];
